import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "@/lib/blog";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";

const Journal = () => {
    const featured = BLOG_POSTS.slice(0, 3);

    return (
        <section
            id="journal"
            data-testid="journal-section"
            className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36"
        >
            <Reveal>
                <ChapterLabel number="Nº 09" title="The Journal" testId="journal-label" />
            </Reveal>
            <Reveal delay={0.1}>
                <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
                    <h2 className="max-w-2xl font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                        STORIES FOR{" "}
                        <span className="italic text-gold">BETTER NIGHTS.</span>
                    </h2>
                    <Link
                        data-testid="journal-view-all-link"
                        to="/blog"
                        className="group inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-gold"
                    >
                        View All
                        <ArrowRight
                            size={14}
                            strokeWidth={1.5}
                            className="transition-transform duration-300 group-hover:translate-x-1.5"
                        />
                    </Link>
                </div>
            </Reveal>

            <div className="mt-14 grid gap-6 md:grid-cols-3">
                {featured.map((p, i) => (
                    <Reveal key={p.slug} delay={0.05 + i * 0.07} className="h-full">
                        <Link
                            data-testid={`journal-card-${p.slug}`}
                            to={`/blog/${p.slug}`}
                            className="card-zoom group flex h-full flex-col overflow-hidden rounded-sm border border-white/10 bg-[#0F0F0F] transition-colors duration-500 hover:border-gold/40"
                        >
                            <div className="relative h-48 overflow-hidden">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-black/30 to-black/10" />
                                <span className="absolute left-5 top-5 border border-gold/40 bg-black/50 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.25em] text-gold backdrop-blur-sm">
                                    {p.category}
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col p-7">
                                <h3 className="font-serif text-xl font-medium leading-snug text-ivory transition-colors duration-300 group-hover:text-gold">
                                    {p.title}
                                </h3>
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted">
                                    {p.excerpt}
                                </p>
                                <span className="mt-6 text-[10px] font-bold uppercase tracking-[0.25em] text-ivory/50">
                                    {p.readTime}
                                </span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </section>
    );
};

export default Journal;
